import type { ApprovalDetailsSection } from '../types';

interface ReturnFeedbackEditState {
  mode: 'editing' | 'idle' | 'saved';
  savedReason: string;
}

export interface ReturnFieldIssue {
  currentValue: string;
  fieldLabel: string;
  fieldPath: string;
  message: string;
}

export interface ReturnFeedbackPayload {
  fieldIssues: ReturnFieldIssue[];
  generalNotes: string;
  returnedAt: string;
  returnedBy: { email: string; first_name: string; id: string; last_name: string };
}

export function buildReturnFieldIssues(
  sections: ApprovalDetailsSection[],
  editStateByRowId: Record<string, ReturnFeedbackEditState>,
): ReturnFieldIssue[] {
  const fieldIssues: ReturnFieldIssue[] = [];

  for (const section of sections) {
    for (const row of section.rows) {
      const editState = editStateByRowId[row.id];
      if (editState?.mode === 'saved') {
        fieldIssues.push({
          currentValue: String(row.value ?? ''),
          fieldLabel: String(row.label ?? ''),
          fieldPath: row.fieldPath ?? row.id,
          message: editState.savedReason,
        });
      }
    }

    for (const group of section.documentGroups ?? []) {
      for (const file of group.documents) {
        const editState = editStateByRowId[file.id];
        if (editState?.mode === 'saved') {
          fieldIssues.push({
            currentValue: file.fileName,
            fieldLabel: group.title,
            fieldPath: file.documentFieldPath,
            message: editState.savedReason,
          });
        }
      }
    }
  }

  return fieldIssues;
}
